module.exports = __webpack_public_path__ + "static/media/productTypeLock.0912b560.svg";